import CheckCircleOutlineIcon from 'mdi-react/CheckCircleOutlineIcon'
import CloseOctagonOutlineIcon from 'mdi-react/CloseOctagonOutlineIcon'
import { useSelector } from 'react-redux'

import { Translation } from '@/components/i18n/Translation'
import { getError, getIsLoaded, getIsLoading } from '@/ducks/apiCallerReducer'

import LoaderCircle from './LoaderCircle'

import './api-caller.scss'

const ApiCaller = ({ loadingText, successText, errorText }: any) => {
  const isLoaded = useSelector(getIsLoaded)
  const isLoading = useSelector(getIsLoading)
  const error = useSelector(getError)

  return (
    <div className="api-caller">
      <ApiCallerContent
        loadingText={loadingText}
        successText={successText}
        errorText={errorText}
        isLoading={isLoading}
        isLoaded={isLoaded}
        error={error}
      />
    </div>
  )
}

export const ApiCallerContent = ({
  isLoading,
  isLoaded,
  error,
  loadingText,
  successText,
  errorText,
}: any) => {
  if (isLoaded) {
    return error ? (
      <div className="error">
        <CloseOctagonOutlineIcon />
        <p>
          <Translation id={errorText} />
        </p>
      </div>
    ) : (
      <div className="success">
        <CheckCircleOutlineIcon />
        <p>
          <Translation id={successText} />
        </p>
      </div>
    )
  }

  if (isLoading)
    return (
      <>
        <LoaderCircle />
        <p>
          <Translation id={loadingText} />
        </p>
      </>
    )

  return null
}

export default ApiCaller
